<script lang="ts">
	import cakeSliceImage from "../../../../core/assets/icons/cake-slice.svg";
	import cakeSliceIconRaw from "../../../../core/assets/icons/cake-slice.svg?raw";
	import Icon from "../Icon.svelte";
	import plus from "../../../../core/assets/icons/btn-plus.svg?raw";
	import Button from "../Button.svelte";
	import ProductOptionHeader from "./ProductOptionHeader.svelte";
	import { calculatePriceForProductOption } from "../../../../core/schema/utils/calculatePriceForProductOption.js";
	import { ProductOption } from "../../../../core/schema/ProductOption.js";
	import type { CakeFilling } from "../../../../core/schema/CakeFilling.js";
	import type { CakeFillingOption } from "../../../../core/schema/CakeFillingOption.js";
	import { getGlobalSettings } from "../../getGlobalSettings.js";

	export let cakeFilling: CakeFilling | undefined;
	export let cakeFillings: CakeFillingOption[];
	export let updateCakeFilling: (filling: CakeFilling | undefined) => void;
	export let basePrice: number;
	export let minimalPricesForOptions: Record<ProductOption, number>;
	export let changed: boolean | undefined;

	function onChange(_cakeFilling: typeof cakeFilling): void {
		if (changed === undefined) {
			changed = false;
			return;
		}
		changed = true;
	}
	$: onChange(cakeFilling);

	const { TENANT_LOCALE, STORAGE_URL } = getGlobalSettings();

	$: minimalPrice = minimalPricesForOptions[ProductOption.CakeFilling];
	$: currentPrice = calculatePriceForProductOption(basePrice, ProductOption.CakeFilling, cakeFilling);

	function selectFilling(filling: CakeFillingOption): void {
		cakeFilling = { productId: filling.productId, name: filling.name };
	}
</script>

<ProductOptionHeader name="Příchuť" image={cakeSliceImage} price={currentPrice} {minimalPrice} minimalPriceIsFinal>
	Vyberte si příchuť náplně Vašeho dortu. U každé vidíte, jak vypadá uvnitř.
</ProductOptionHeader>

<div class="grid grid-cols-2 gap-3 sm:grid-cols-3">
	{#each cakeFillings as filling (filling.productId)}
		{@const id = `cakeFilling-${filling.productId}`}
		{@const selected = cakeFilling?.productId === filling.productId}
		<label
			for={id}
			class="group relative flex cursor-pointer flex-col overflow-hidden rounded-xl border transition hover:border-secondary hover:shadow-sm"
			class:border-secondary={selected}
			class:border-secondary-200={!selected}
			class:shadow-sm={selected}
		>
			<input
				type="radio"
				{id}
				name="cakeFilling"
				class="pointer-events-none absolute inset-0 opacity-0"
				checked={selected}
				on:change={() => {
					selectFilling(filling);
				}}
				required
			/>
			{#if filling.imagePath}
				<div class="aspect-square w-full overflow-hidden bg-secondary-100">
					<img
						src="{STORAGE_URL}/{filling.imagePath}"
						alt={filling.name[TENANT_LOCALE]}
						loading="lazy"
						class="h-full w-full object-cover transition duration-300 group-hover:scale-105"
					/>
				</div>
			{:else}
				<div class="flex aspect-square w-full items-center justify-center bg-secondary-200">
					<Icon icon={cakeSliceIconRaw} class="h-9 text-secondary-300" />
				</div>
			{/if}
			<span
				class="flex min-h-[2.75rem] items-center justify-center px-2 py-1.5 text-center text-xs font-semibold leading-tight text-secondary"
			>
				{filling.name[TENANT_LOCALE]}
			</span>
			{#if selected}
				<span
					class="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-secondary text-2xs font-bold text-white"
				>
					✓
				</span>
			{/if}
		</label>
	{/each}
</div>

<Button
	icon={plus}
	iconClass="w-5 h-5"
	class="ml-auto mt-6"
	on:click={() => {
		updateCakeFilling(cakeFilling);
	}}
>
	Uložit úpravu
</Button>
